<template>
  <div id="app">
    <nav class="navbar">
      <div class="logo">
        <span>TCO Frontend</span>
      </div>
      <div class="nav-links">
        <router-link to="/" v-if="isAuthenticated">Workbench</router-link>
        <a @click="logout" v-if="isAuthenticated" class="logout-link">Logout</a>
      </div>
    </nav>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isAuthenticated: false
    }
  },
  created() {
    // Check authentication status when component is created
    this.checkAuth()
    // Listen for storage events (for multi-tab synchronization)
    window.addEventListener('storage', this.checkAuth)
  },
  mounted() {
    // Initial check on mount
    this.checkAuth()
  },
  watch: {
    // Watch for route changes to check auth status
    '$route': {
      handler() {
        this.checkAuth()
      },
      immediate: true
    }
  },
  beforeUnmount() {
    // Clean up event listener
    window.removeEventListener('storage', this.checkAuth)
  },
  methods: {
    checkAuth() {
      this.isAuthenticated = localStorage.getItem('isAuthenticated') === 'true'
    },
    logout() {
      localStorage.removeItem('isAuthenticated')
      this.isAuthenticated = false
      this.$router.push('/login')
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.logo {
  display: flex;
  align-items: center;
}

.logo-img {
  height: 40px;
  margin-right: 10px;
}

.logo span {
  font-size: 1.5rem;
  font-weight: bold;
  color: #42b983;
}

.nav-links {
  display: flex;
  gap: 20px;
}

.nav-links a {
  color: #2c3e50;
  text-decoration: none;
  font-weight: 500;
  padding: 0.5rem;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.nav-links a:hover {
  color: #42b983;
}

.nav-links a.router-link-active {
  color: #42b983;
  font-weight: bold;
}

.logout-link {
  cursor: pointer;
}

/* Reset some default styles */
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
